import { SvgIcon, SxProps } from "@mui/material";
import FallbackAvatarFemaleSvg from "jsx:../../../Images/Icons/Custom/fallbackAvatarFemale.svg";

export function AvatarFemaleFallbackIcon(props: SxProps) {
    return (
        <SvgIcon
            component={FallbackAvatarFemaleSvg}
            inheritViewBox
            sx={props}
        />
    );
}
